import { Routes } from '@angular/router';

import { Roles } from '@cure-common/enum';
import { authenticationGuard, CanLeaveGuard, RoleGuard } from '@cure-guards/index';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () =>
      import('./layout/auth-layout/auth-layout.component').then((m) => m.AuthLayoutComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'sign-in',
      },
      {
        path: 'sign-in',
        loadComponent: () =>
          import('./pages/sign-in/sign-in.component').then((m) => m.SignInComponent),
      },
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then((m) => m.MainLayoutComponent),
    canActivate: [authenticationGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'menu-admin',
        loadComponent: () =>
          import('./pages/menu-admin/menu-admin.component').then((m) => m.MenuAdminComponent),
        canActivate: [RoleGuard(Roles.ADMIN)],
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        canActivate: [RoleGuard(Roles.ADMIN)],
      },
      {
        path: 'orders',
        loadComponent: () =>
          import('./pages/orders/orders.component').then((m) => m.OrdersComponent),
      },
      {
        path: 'orders/:id',
        loadComponent: () =>
          import('./pages/order-single/order-single.component').then((m) => m.OrderSingleComponent),
      },
      {
        path: 'vendors',
        loadComponent: () =>
          import('./pages/vendors/vendors.component').then((m) => m.VendorsComponent),
      },
      {
        path: 'vendors/edit/:id',
        loadComponent: () =>
          import('./pages/vendor-single/vendor-edit/vendor-edit.component').then(
            (m) => m.VendorEditComponent,
          ),
        canDeactivate: [CanLeaveGuard],
      },
      {
        path: 'vendors/create',
        loadComponent: () =>
          import('./pages/vendor-single/vendor-create/vendor-create.component').then(
            (m) => m.VendorCreateComponent,
          ),
      },
      {
        path: 'users',
        loadComponent: () => import('./pages/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'ai-reservations',
        loadComponent: () =>
          import('./pages/ai-reservations/ai-reservations.component').then(
            (m) => m.AiReservationsComponent,
          ),
      },
      {
        path: 'ai-reservations/:id',
        loadComponent: () =>
          import('./pages/ai-reservation-single/ai-reservation-single.component').then(
            (m) => m.AiReservationSingleComponent,
          ),
      },
      {
        path: 'ai-general-info',
        loadComponent: () =>
          import('./pages/ai-general-info/ai-general-info.component').then(
            (m) => m.AiGeneralInfoComponent,
          ),
      },
      {
        path: 'ai-statistic',
        loadComponent: () =>
          import('./pages/ai-statistic/ai-statistic.component').then((m) => m.AiStatisticComponent),
      },
      {
        path: 'tickets',
        loadComponent: () =>
          import('./pages/tickets/tickets.component').then((m) => m.TicketsComponent),
      },
      {
        path: 'working-hours',
        loadComponent: () =>
          import('./pages/working-hours/working-hours.component').then(
            (m) => m.WorkingHoursComponent,
          ),
        canDeactivate: [CanLeaveGuard],
      },
      {
        path: 'partners',
        loadComponent: () =>
          import('./pages/partners/partners.component').then((m) => m.PartnersComponent),
      },
      {
        path: 'partners/create',
        loadComponent: () =>
          import('./pages/partner-single/partner-create/partner-create.component').then(
            (m) => m.PartnerCreateComponent,
          ),
      },
      {
        path: 'partners/edit/:id',
        loadComponent: () =>
          import('./pages/partner-single/partner-edit/partner-edit.component').then(
            (m) => m.PartnerEditComponent,
          ),
        canDeactivate: [CanLeaveGuard],
      },
      {
        path: 'reservations',
        loadComponent: () =>
          import('./pages/reservations/reservations.component').then(
            (m) => m.ReservationsComponent,
          ),
      },
      {
        path: 'reservations/:id',
        loadComponent: () =>
          import('./pages/reservation-single/reservation-single.component').then(
            (m) => m.ReservationSingleComponent,
          ),
      },
      {
        path: 'payments/pharmacy-payouts',
        loadComponent: () =>
          import('./pages/pharmacy-payouts/pharmacy-payouts.component').then(
            (m) => m.PharmacyPayoutsComponent,
          ),
      },
      {
        path: 'cannabis-reviews',
        loadComponent: () =>
          import('./pages/cannabis-reviews/cannabis-reviews.component').then(
            (m) => m.CannabisReviewsComponent,
          ),
      },
    ],
  },
];
